import { loadCanvasThumbnail } from "../../lib/canvas-thumbnail-cache";
import { navigate } from "../../router";

interface Props {
  readonly canvasId: string;
  readonly title: string;
  readonly updatedAt: string;
  readonly thumbnailUrl?: string | undefined;
}

// f379c03 以前のシンプルなカードレイアウトに回帰。
// @meiden-connect/ui の Button を使うとデザインシステムの padding/grid が干渉するため、
// あえて素の <button> + インラインスタイルで TOP の見た目を維持する。
export function RecentCanvasCard({ canvasId, title, updatedAt, thumbnailUrl }: Props): JSX.Element {
  const cachedThumbnail = loadCanvasThumbnail(canvasId);
  const coverUrl = cachedThumbnail ?? thumbnailUrl;

  return (
    <button
      type="button"
      onClick={() => navigate(`/c/${canvasId}`)}
      style={{
        display: "block",
        width: "100%",
        padding: 0,
        border: "1px solid var(--color-border)",
        borderRadius: "var(--radius-2)",
        background: "var(--color-surface)",
        textAlign: "left",
        overflow: "hidden",
        boxShadow: "var(--shadow-1)",
        color: "inherit",
      }}
    >
      <div
        style={{
          aspectRatio: "16 / 9",
          background: coverUrl
            ? `url(${coverUrl}) center/cover`
            : "var(--color-surface-muted)",
        }}
      />
      <div style={{ padding: "12px 16px" }}>
        <div style={{ fontWeight: 600, marginBottom: "4px" }}>{title}</div>
        <div style={{ fontSize: "12px", color: "var(--color-text-muted)" }}>{updatedAt}</div>
      </div>
    </button>
  );
}
